import pluralize from 'pluralize';

angular.module('filters').filter('membershipPlanPaymentFilter', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(membershipPlan, currency) {
    var cost_repeat, symbol;
    if (membershipPlan.cost_repeat > 0 && ('recurring' === membershipPlan.type || 'recurring' === membershipPlan.plan_type)) {
      symbol = currency || $rootScope.gym.currency_symbol;
      cost_repeat = $filter('currency')(membershipPlan.cost_repeat, symbol);
      if (membershipPlan.charge_interval_number > 1) {
        return `${cost_repeat} every ${membershipPlan.charge_interval_number} ${membershipPlan.charge_interval_unit}`;
      } else {
        return `${cost_repeat}/${pluralize.singular(membershipPlan.charge_interval_unit)}`;
      }
    } else {
      return "No recurring payment";
    }
  };
}]);
